This is the Print Preview For Closing Process, rendering ISectionData of PDF Tron Mapper

<div>Print Preview: {{ sectionData.title }}</div>
<div>Company: {{ sectionData.data }}</div>
